export const terminalTypeOptions = [
  'Altura',
  'Altura Compact',
  'CDS',
  'EDSQ 16',
  'EDSQ 24',
  'Flex',
  'Gamepoint',
  'Game Touch 20',
  'Game Touch 28',
  'Game Touch Draw',
  'Gemini',
  'Gemini Touch',
  'Gemini Ultra',
  'GT20',
  'GT1200',
  'GT1200 Compact',
  'Lottery Inside',
  'Retailer Pro',
  'SST',
];

export const communicationsTypeOptions = [
  { value: 'hughes/vsat', label: 'Hughes/Vsat' },
  { value: 'ventus/Cell', label: 'Ventus/Cell' },
  { value: 'digi/Cell', label: 'Digi/Cell' },
];

export const keyTypeOptions = [
  { value: 'billAcceptorDoor', label: 'Bill Acceptor Door' },
  { value: 'frontMainDoor', label: 'Front/Main Door' },
];
